module.exports = __webpack_public_path__ + "img/ic_64_feature_lieblingsteam.4f9aa06d.svg";